import "core-js/modules/es.number.constructor.js";
import { defineComponent as _defineComponent } from 'vue';
import CardExportFooter from '~/components/export/CardFooter.vue';
import CardExportHeader from '~/components/export/CardHeader.vue';
import { EXPORT_MIN_SCALE_STRATEGY } from '~/functions/export-scale';
export default /*#__PURE__*/_defineComponent({
  __name: 'ImpactCards',
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    loadingLabel: {
      type: String,
      default: ''
    },
    companyName: {
      type: String,
      required: true
    },
    exportedAt: {
      type: [Date, String, Number],
      required: true
    }
  },
  setup: function setup(__props, _ref) {
    var expose = _ref.expose;
    var strategyPageRef = ref(null);
    var recalculateAll = function recalculateAll() {
      var _strategyPageRef$valu;
      (_strategyPageRef$valu = strategyPageRef.value) === null || _strategyPageRef$valu === void 0 ? void 0 : _strategyPageRef$valu.recalculate();
    };
    expose({
      recalculateAll: recalculateAll
    });
    return {
      __sfc: true,
      strategyPageRef: strategyPageRef,
      recalculateAll: recalculateAll,
      CardExportFooter: CardExportFooter,
      CardExportHeader: CardExportHeader,
      EXPORT_MIN_SCALE_STRATEGY: EXPORT_MIN_SCALE_STRATEGY
    };
  }
});